"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7273 12c0 .5969.2436 1.185.6656 1.6071.4221.422 1.0102.6656 1.6071.6656V17c-1.3132 0-2.607-.5359-3.5355-1.4645C7.5359 14.6069 7 13.3132 7 12h2.7273z",
    fill: "#DA3E8B"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2727 12H17c0 1.3132-.5359 2.6069-1.4645 3.5355C14.6069 16.4641 13.3132 17 12 17v-2.7273c.5969 0 1.185-.2436 1.6071-.6656.422-.4221.6656-1.0102.6656-1.6071z",
    fill: "#F1D07F"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7c1.3132 0 2.6069.5359 3.5355 1.4645C16.4641 9.393 17 10.6868 17 12h-2.7273c0-.5969-.2436-1.185-.6656-1.6071-.4221-.422-1.0102-.6656-1.6071-.6656V7z",
    fill: "#7FCB67"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7v2.7273c-.5969 0-1.185.2436-1.6071.6656-.422.4221-.6656 1.0102-.6656 1.6071H7c0-1.3132.5359-2.607 1.4645-3.5355C9.393 7.5359 10.6868 7 12 7z",
    fill: "#00BDFF"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm-9 7c0-4.9706 4.0294-9 9-9s9 4.0294 9 9-4.0294 9-9 9-9-4.0294-9-9z"
  })];
};

exports.default = _default;